module.exports = __webpack_public_path__ + "img/introduce_search.906cc789.png";